import React from 'react';
import type { AgendyAisOvmDto } from '@gov-nx/api';
import { useOvmSearchAutocomplete } from '@gov-nx/core/hooks';
import {
	LocalizeNameSpaceTypes,
	useTranslationWithNamespace,
} from '@gov-nx/core/service';
import type { FormAutocompleteProps } from '../FormAutocomplete';
import { FormAutocomplete } from '../FormAutocomplete';

export interface OvmSearchAutocompleteProps extends Omit<
	FormAutocompleteProps<AgendyAisOvmDto>,
	'field'
> {
	field: Omit<
		FormAutocompleteProps<AgendyAisOvmDto>['field'],
		| 'templateResolver'
		| 'nameKey'
		| 'searchCallback'
		| 'keyResolver'
		| 'valueResolver'
	>;
	maAgendy: boolean;
}

const templateResolver = ({ nazev, datovaSchrankaId }: AgendyAisOvmDto) => (
	<span>
		{nazev ?? ''} {datovaSchrankaId ? <i>({datovaSchrankaId})</i> : null}
	</span>
);

const valueResolver = ({ nazev }: AgendyAisOvmDto): string => nazev ?? '';

const keyResolver = ({ kod }: AgendyAisOvmDto): string => kod ?? '';

export const OvmSearchAutocomplete = (props: OvmSearchAutocompleteProps) => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const t = getLocalizeCurried(LocalizeNameSpaceTypes.Form);
	const { searchCallback } = useOvmSearchAutocomplete({
		maAgendy: props.maAgendy,
	});

	return (
		<FormAutocomplete<AgendyAisOvmDto>
			label={props.label}
			field={{
				...props.field,
				minlength: 3,
				messageEmpty:
					props.field.messageEmpty ?? t('naseptavac.pole.zadny-vysledek'),
				templateResolver,
				valueResolver,
				keyResolver,
				searchCallback,
			}}
		/>
	);
};
